<template>
  <div class="mf-materials-filters-entry">
    <Dropdown
      v-model:shown="isDropdownVisible"
      class="mf-materials-filters-entry-wrapper"
      @hide="$emit('hide')"
    >
      <button class="mf-materials-filters-entry-button">
        <slot name="button" />
      </button>
      <template #popper>
        <div class="mf-materials-filters-entry-dropdown">
          <slot name="dropdown" />
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Dropdown } from "floating-vue";

defineProps({});
defineEmits(["hide"]);
const isDropdownVisible = ref(false);

const hidePopover = () => {
  isDropdownVisible.value = false;
};

defineExpose({
  hidePopover,
});
</script>
